import { freeRoomApplyOrderRepository } from '@/repositories/Index'

class FreeRoomApplyOrderService {
	async queryPromotionRoomTypeDetail(params: any) {
		const res = await freeRoomApplyOrderRepository.queryPromotionRoomTypeDetail(params)
		return res
	}

	async confirm(params: any) {
		const res = await freeRoomApplyOrderRepository.confirm(params)
		return res
	}

	async getHotelConfirmRecord(params: any) {
		const res = await freeRoomApplyOrderRepository.getHotelConfirmRecord(params)
		return res
	}
}

export default FreeRoomApplyOrderService
